import { render, staticRenderFns } from "./CustomerWallet.vue?vue&type=template&id=66b9b64c&scoped=true&"
import script from "./CustomerWallet.vue?vue&type=script&lang=ts&"
export * from "./CustomerWallet.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerWallet.vue?vue&type=style&index=0&id=66b9b64c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b9b64c",
  null
  
)

export default component.exports